module.exports = __webpack_public_path__ + "static/media/szechenyi_2020_befektetes_a_jovobe_kedvezmenyezett.01d75acb.png";